var map = {
	"./Andrew Coutts (1).jpg_Top only.jpg": 2149,
	"./Bongani Madikiza_CEO_Sanlam Retail Mass.png": 1927,
	"./SantamCeoAwardCats.png": 6358,
	"./SantamCeoAwardTava.png": 8335,
	"./ceogo.jpg": 1785,
	"./ceosbs.jpg": 3350,
	"./ceosbs_OLD.jpg": 3603,
	"./ceosbs_new.jpg": 2690,
	"./ceosc.jpg": 3683,
	"./ceosc_old.jpg": 8895,
	"./ceosem.jpg": 5532,
	"./ceosig.jpg": 2614,
	"./ceosig_OLD.jpg": 4784,
	"./ceosra.jpg": 445,
	"./ceosraOLD250328.jpg": 2153,
	"./ceosrm.jpg": 1703,
	"./ceosrm_OLD.jpg": 3263,
	"./ceosrm_OLD2.jpg": 4513,
	"./ceosss.jpg": 4492,
	"./ceostm.jpg": 5540,
	"./ceostm_old.jpg": 764,
	"./ceostmclaimscco.jpg": 30,
	"./ceostmclaimshead.jpg": 494,
	"./ceostmre.jpg": 4400,
	"./ceostmre_old.jpg": 5399,
	"./ceostmre_uncompressed.jpg": 2730,
	"./emailpics214/anniversary01-05.png": 1938,
	"./emailpics214/anniversary06-10.png": 1136,
	"./emailpics214/anniversary11-15.png": 5163,
	"./emailpics214/anniversary16-20.png": 8788,
	"./emailpics214/anniversary21-x.png": 9518,
	"./emailpics214/birthday01.jpg": 7914,
	"./emailpics214/birthday02.jpg": 524,
	"./emailpics214/birthday03.jpg": 3607,
	"./emailpics214/birthday04.jpg": 1931,
	"./emailpics214/birthday05.jpg": 3846,
	"./emailpics214/birthday06.jpg": 5103,
	"./emailpics214/birthday07.jpg": 9999,
	"./emailpics214/birthday08.jpg": 2774,
	"./emailpics214/birthday09.jpg": 8728,
	"./emailpics214/birthday10.jpg": 9030,
	"./emailpics214/birthday11.jpg": 9294,
	"./emailpics214/birthday12.jpg": 9046,
	"./emailpics214/logofooter_safrican.png": 8644,
	"./emailpics214/logofooter_sanlam.png": 1963,
	"./emailpics214/logofooter_sanlam_old.png": 4982,
	"./emailpics214/logofooter_santam.png": 2586,
	"./emailpics214/old2023/anniversary01-05.png": 59,
	"./emailpics214/old2023/anniversary06-10.png": 941,
	"./emailpics214/old2023/anniversary11-15.png": 6441,
	"./emailpics214/old2023/anniversary16-19.png": 799,
	"./emailpics214/old2023/anniversary20-x.png": 1558,
	"./emailpics214/old2023/birthday01.jpg": 357,
	"./emailpics214/old2023/birthday01.png": 3216,
	"./emailpics214/old2023/birthday02.jpg": 7194,
	"./emailpics214/old2023/birthday02.png": 9468,
	"./emailpics214/old2023/birthday03.jpg": 2253,
	"./emailpics214/old2023/birthday03.png": 4114,
	"./emailpics214/old2023/birthday04.jpg": 1,
	"./emailpics214/old2023/birthday04.png": 8768,
	"./emailpics214/old2023/birthday05.jpg": 367,
	"./emailpics214/old2023/birthday05.png": 8419,
	"./emailpics214/old2023/birthday06.jpg": 3949,
	"./emailpics214/old2023/birthday06.png": 8754,
	"./emailpics214/old2023/birthday07.jpg": 2199,
	"./emailpics214/old2023/birthday07.png": 7090,
	"./emailpics214/old2023/birthday08.jpg": 2700,
	"./emailpics214/old2023/birthday08.png": 8649,
	"./emailpics214/old2023/birthday09.jpg": 8524,
	"./emailpics214/old2023/birthday09.png": 8684,
	"./emailpics214/old2023/birthday10.jpg": 8088,
	"./emailpics214/old2023/birthday10.png": 8961,
	"./emailpics214/old2023/birthday11.jpg": 480,
	"./emailpics214/old2023/birthday11.png": 7708,
	"./emailpics214/old2023/birthday12.jpg": 4266,
	"./emailpics214/old2023/birthday12.png": 476,
	"./emailpics214/old2023/workanniversary.png": 1838,
	"./emailpics214/old2024/anniversary01-05.png": 6727,
	"./emailpics214/old2024/anniversary06-10.png": 2842,
	"./emailpics214/old2024/anniversary11-15.png": 8504,
	"./emailpics214/old2024/anniversary16-19.png": 5670,
	"./emailpics214/old2024/anniversary20-x.png": 1140,
	"./emailpics214/old2024/birthday01.jpg": 7405,
	"./emailpics214/old2024/birthday01.png": 6337,
	"./emailpics214/old2024/birthday02.jpg": 6242,
	"./emailpics214/old2024/birthday02.png": 5915,
	"./emailpics214/old2024/birthday03.jpg": 2430,
	"./emailpics214/old2024/birthday03.png": 4314,
	"./emailpics214/old2024/birthday04.jpg": 2861,
	"./emailpics214/old2024/birthday04.png": 9322,
	"./emailpics214/old2024/birthday05.jpg": 2664,
	"./emailpics214/old2024/birthday05.png": 9665,
	"./emailpics214/old2024/birthday06.jpg": 5861,
	"./emailpics214/old2024/birthday06.png": 9316,
	"./emailpics214/old2024/birthday07.jpg": 8639,
	"./emailpics214/old2024/birthday07.png": 2496,
	"./emailpics214/old2024/birthday08.jpg": 1664,
	"./emailpics214/old2024/birthday08.png": 4840,
	"./emailpics214/old2024/birthday09.jpg": 239,
	"./emailpics214/old2024/birthday09.png": 8619,
	"./emailpics214/old2024/birthday10.jpg": 6317,
	"./emailpics214/old2024/birthday10.png": 561,
	"./emailpics214/old2024/birthday11.jpg": 7367,
	"./emailpics214/old2024/birthday11.png": 1335,
	"./emailpics214/old2024/birthday12.jpg": 9630,
	"./emailpics214/old2024/birthday12.png": 6915,
	"./emailpics214/old2024/logofooter_safrican.png": 8967,
	"./emailpics214/old2024/logofooter_sanlam.png": 4565,
	"./emailpics214/old2024/logofooter_santam.png": 9408,
	"./emailpics214/old2024/workanniversary.png": 7970,
	"./emailpics214/workanniversary.png": 5609,
	"./groupExecHC.jpg": 717,
	"./gugu.png": 7999,
	"./headerEmailLogo3OLD.png": 8703,
	"./humancapitalJM.jpg": 5649,
	"./loading-bar.gif": 295,
	"./nopic.jpg": 2610,
	"./rportalBullet.png": 3989,
	"./rportalIconHow.png": 5925,
	"./rportalIconLogin.png": 392,
	"./rportalIconRegister.png": 6057,
	"./safrican/butAwardBusiness.jpg": 4295,
	"./safrican/butAwardHumanCapital.jpg": 7763,
	"./safrican/cardClientFocus.jpg": 2984,
	"./safrican/cardCollaborates.jpg": 4342,
	"./safrican/cardCongratulations.jpg": 4760,
	"./safrican/cardCultivatesInnovation.jpg": 6803,
	"./safrican/cardDrivesResults.jpg": 6680,
	"./safrican/cardFlexibilityAndAdaptability.jpg": 2649,
	"./safrican/cardThankYou.jpg": 2428,
	"./safrican/cardThumbsUpToYou.jpg": 9714,
	"./safrican/cardUnknown.jpg": 2069,
	"./safrican/cardYouMadeADifference.jpg": 557,
	"./safrican/cardYouRockWellDone.jpg": 2573,
	"./safrican/cardYoureTheBest.jpg": 7713,
	"./safrican/ceogo.jpg": 6208,
	"./safrican/ceosem.jpg": 6047,
	"./safrican/ceosig.jpg": 1019,
	"./safrican/ceospf.jpg": 8579,
	"./safrican/ceostm.jpg": 9587,
	"./safrican/footerlogo.png": 4820,
	"./safrican/headerEmailAnniversary.jpg": 7145,
	"./safrican/headerEmailBirthday.jpg": 917,
	"./safrican/headerEmailLogo3.png": 2075,
	"./safrican/headerEmailLogo3OLD.png": 9639,
	"./safrican/homeIcon1.jpg": 6215,
	"./safrican/homeIcon2.jpg": 6663,
	"./safrican/homeIcon2L.jpg": 1847,
	"./safrican/homeIcon2r1.jpg": 98,
	"./safrican/homeIcon2r2.jpg": 6258,
	"./safrican/homeIcon2r2blank.jpg": 21,
	"./safrican/homeIcon2r3.jpg": 8282,
	"./safrican/homeIcon2r4.jpg": 408,
	"./safrican/homeIcon2r5.jpg": 8591,
	"./safrican/homeIcon3.jpg": 6673,
	"./safrican/homeIcon3PIF.jpg": 7021,
	"./safrican/homeIcon3redeem.jpg": 4647,
	"./safrican/homeIcon3sp1.jpg": 2212,
	"./safrican/homeIcon3sp2.jpg": 2363,
	"./safrican/homeIcon3top.jpg": 1987,
	"./safrican/homeIcon4.jpg": 1943,
	"./safrican/homeIcon5.jpg": 3059,
	"./safrican/homeIcon6.jpg": 267,
	"./safrican/loading-bar.gif": 9520,
	"./safrican/nopic.jpg": 4079,
	"./safrican/spacer.gif": 6211,
	"./safrican/spfCEOAward.jpg": 2238,
	"./safrican/spfClientChampionAward.jpg": 6028,
	"./safrican/spfInfluencerAward.jpg": 2866,
	"./safrican/spfInnovationAward.jpg": 829,
	"./safrican/topHeadLogo.png": 7648,
	"./safrican/topHeadLogoRt.png": 9868,
	"./safrican/topRecognition.jpg": 4625,
	"./safrican/topShoutOut.jpg": 3392,
	"./safrican/topheadbg.png": 3366,
	"./safrican/voucherlogo.gif": 6751,
	"./safrican/wait.gif": 9633,
	"./safrican/wait300.gif": 9366,
	"./sanlam/All Star Trip.png": 5719,
	"./sanlam/HC Awards Tile Test2.jpg": 5227,
	"./sanlam/HC Awards Tile-test.jpg": 257,
	"./sanlam/butAwardBusiness.jpg": 1899,
	"./sanlam/butAwardBusiness2.jpg": 3310,
	"./sanlam/butAwardBusiness4.jpg": 108,
	"./sanlam/butAwardBusinessOLD.jpg": 1937,
	"./sanlam/butAwardHumanCapital - Copy.jpg": 9211,
	"./sanlam/butAwardHumanCapital.jpg": 633,
	"./sanlam/butAwardHumanCapital3.jpg": 4587,
	"./sanlam/butAwardHumanCapitalHvr.jpg": 5662,
	"./sanlam/butAwardSLS.jpg": 730,
	"./sanlam/cardClientFocus.jpg": 3072,
	"./sanlam/cardCollaborates.jpg": 8130,
	"./sanlam/cardCongratulations.jpg": 3988,
	"./sanlam/cardCultivatesInnovation.jpg": 9569,
	"./sanlam/cardDrivesResults.jpg": 9905,
	"./sanlam/cardFlexibilityAndAdaptability.jpg": 878,
	"./sanlam/cardThankYou.jpg": 6858,
	"./sanlam/cardThumbsUpToYou.jpg": 8822,
	"./sanlam/cardUnknown.jpg": 4595,
	"./sanlam/cardYouMadeADifference.jpg": 5914,
	"./sanlam/cardYouRockWellDone.jpg": 1592,
	"./sanlam/cardYoureTheBest.jpg": 5679,
	"./sanlam/ceogo.jpg": 4001,
	"./sanlam/ceosem.jpg": 854,
	"./sanlam/ceosig.jpg": 6295,
	"./sanlam/ceospf.jpg": 194,
	"./sanlam/ceostm.jpg": 779,
	"./sanlam/footerlogo.png": 1856,
	"./sanlam/groupExecHC.jpg": 1962,
	"./sanlam/headerEmailAnniversary.jpg": 7337,
	"./sanlam/headerEmailBirthday.jpg": 6333,
	"./sanlam/headerEmailLogo3.png": 7504,
	"./sanlam/headerEmailLogo3OLD.png": 8971,
	"./sanlam/homeIcon1.jpg": 7409,
	"./sanlam/homeIcon1.png": 6031,
	"./sanlam/homeIcon1OLD.jpg": 3840,
	"./sanlam/homeIcon2.jpg": 3475,
	"./sanlam/homeIcon2L.jpg": 578,
	"./sanlam/homeIcon2r1.jpg": 2835,
	"./sanlam/homeIcon2r2.jpg": 3720,
	"./sanlam/homeIcon2r2blank.jpg": 8216,
	"./sanlam/homeIcon2r3.jpg": 4778,
	"./sanlam/homeIcon2r4.jpg": 8295,
	"./sanlam/homeIcon2r5.jpg": 2202,
	"./sanlam/homeIcon3.jpg": 3898,
	"./sanlam/homeIcon3PIF.jpg": 4955,
	"./sanlam/homeIcon3redeem.jpg": 3820,
	"./sanlam/homeIcon3sp1.jpg": 125,
	"./sanlam/homeIcon3sp2.jpg": 6570,
	"./sanlam/homeIcon3top.jpg": 6646,
	"./sanlam/homeIcon4.jpg": 2731,
	"./sanlam/homeIcon5.jpg": 8771,
	"./sanlam/homeIcon6.jpg": 8812,
	"./sanlam/loading-bar.gif": 1832,
	"./sanlam/nomAllStarsBanner.jpg": 7338,
	"./sanlam/nomAllStarsBanner_OLD.jpg": 5669,
	"./sanlam/nomAllStarsBanner_OLD2026.jpg": 2157,
	"./sanlam/nopic.jpg": 1604,
	"./sanlam/rportalBullet.png": 8281,
	"./sanlam/rportalIconHow.png": 715,
	"./sanlam/rportalIconLogin.png": 1047,
	"./sanlam/rportalIconRegister.png": 9703,
	"./sanlam/slsaward_ceo.jpg": 5042,
	"./sanlam/slsaward_experience.jpg": 6997,
	"./sanlam/slsaward_fusion.jpg": 2094,
	"./sanlam/slsaward_innovator.jpg": 1032,
	"./sanlam/slsaward_ubuholi.jpg": 3254,
	"./sanlam/spacer.gif": 9108,
	"./sanlam/spfAllStarsIncentive.jpg": 9112,
	"./sanlam/spfCEOAward.jpg": 4984,
	"./sanlam/spfClientChampionAward.jpg": 7707,
	"./sanlam/spfInfluencerAward.jpg": 1609,
	"./sanlam/spfInnovationAward.jpg": 9239,
	"./sanlam/topHeadBg.jpg": 8939,
	"./sanlam/topHeadLogo.png": 9473,
	"./sanlam/topHeadLogoRt - Copy.png": 8904,
	"./sanlam/topHeadLogoRt.png": 9644,
	"./sanlam/topRecognition.jpg": 2954,
	"./sanlam/topShoutOut.jpg": 2789,
	"./sanlam/topheadbg.png": 2201,
	"./sanlam/wait.gif": 4478,
	"./sanlam/wait300.gif": 798,
	"./santam/ATANG HEADSHOT.jpg": 2988,
	"./santam/butAwardBusiness.jpg": 7072,
	"./santam/butAwardHumanCapital.jpg": 2742,
	"./santam/butAwardSantamBrokerSolutions.jpg": 9142,
	"./santam/butAwardSantamCEO.jpg": 7083,
	"./santam/butAwardSantamCEOVote.jpg": 1910,
	"./santam/butAwardSantamCEOVote_OLD.jpg": 3762,
	"./santam/butAwardSantamCEO_OLD (2).jpg": 5101,
	"./santam/butAwardSantamCEO_OLD.jpg": 1465,
	"./santam/butAwardSantamClaimsLaduma.jpg": 2924,
	"./santam/butAwardSantamClientSolutions.jpg": 9628,
	"./santam/butAwardSantamHumanCapital.jpg": 362,
	"./santam/butAwardSantamRE.jpg": 2863,
	"./santam/butAwardSantamSharedServices.jpg": 6631,
	"./santam/butAwardSantamSharedServices_OLD.jpg": 9675,
	"./santam/butAwardSantamSpecialisedSolutions.jpg": 3324,
	"./santam/cardClientFocus.jpg": 6660,
	"./santam/cardCollaborates.jpg": 9004,
	"./santam/cardCongratulations.jpg": 6257,
	"./santam/cardCultivatesInnovation.jpg": 1271,
	"./santam/cardDrivesResults.jpg": 7878,
	"./santam/cardFlexibilityAndAdaptability.jpg": 1867,
	"./santam/cardThankYou.jpg": 5405,
	"./santam/cardThumbsUpToYou.jpg": 8440,
	"./santam/cardUnknown.jpg": 2162,
	"./santam/cardYouMadeADifference.jpg": 3178,
	"./santam/cardYouRockWellDone.jpg": 9424,
	"./santam/cardYoureTheBest.jpg": 9591,
	"./santam/ceoawards-banner.png": 5901,
	"./santam/ceostm.jpg": 694,
	"./santam/footerlogo.png": 7528,
	"./santam/headerEmailAnniversary.jpg": 3632,
	"./santam/headerEmailBirthday.jpg": 5612,
	"./santam/headerEmailLogo3.png": 6916,
	"./santam/headerEmailLogo3OLD.png": 3441,
	"./santam/homeIcon1.jpg": 4966,
	"./santam/homeIcon1.png": 491,
	"./santam/homeIcon2L.jpg": 9075,
	"./santam/homeIcon2r1.jpg": 4573,
	"./santam/homeIcon2r2.jpg": 1406,
	"./santam/homeIcon2r2blank.jpg": 3132,
	"./santam/homeIcon2r3.jpg": 6077,
	"./santam/homeIcon2r4.jpg": 4116,
	"./santam/homeIcon2r5.jpg": 1868,
	"./santam/homeIcon3.jpg": 563,
	"./santam/homeIcon3PIF.jpg": 3339,
	"./santam/homeIcon3redeem.jpg": 8628,
	"./santam/homeIcon3sp1.jpg": 4770,
	"./santam/homeIcon3sp2.jpg": 6871,
	"./santam/homeIcon3top.jpg": 4470,
	"./santam/homeIcon4.jpg": 6716,
	"./santam/homeIcon5.jpg": 151,
	"./santam/homeIcon6.jpg": 9019,
	"./santam/homeViewMore.png": 238,
	"./santam/loading-bar.gif": 6497,
	"./santam/logofooter.jpg": 2739,
	"./santam/logofooter.png": 4798,
	"./santam/nopic.jpg": 574,
	"./santam/santamclaimsladuma_iqhawe.jpg": 6835,
	"./santam/santamclaimsladuma_kham.jpg": 8815,
	"./santam/santamclaimsladuma_langa.jpg": 4022,
	"./santam/santamclaimsladuma_molathladi.jpg": 8532,
	"./santam/santamclaimsladuma_morningstar.jpg": 4468,
	"./santam/santamclaimsladuma_nwedzi.jpg": 4230,
	"./santam/santamclaimsladuma_selemela.jpg": 4546,
	"./santam/santamclaimsladuma_suiderkruis.jpg": 353,
	"./santam/santamclaimsladuma_tinyeleti.jpg": 7722,
	"./santam/santamhumancapitalawardcats.png": 6099,
	"./santam/santamre_actwithcourage.jpg": 3396,
	"./santam/santamre_owntheoutcome.jpg": 3276,
	"./santam/santamre_respect.jpg": 1022,
	"./santam/santamre_risetogether.jpg": 5066,
	"./santam/santamsharedservicesheader.png": 6711,
	"./santam/spacer.gif": 3983,
	"./santam/tmp/banner.jpg": 9315,
	"./santam/tmp/topHeadLogoRt.png": 1835,
	"./santam/tmp/topheadbg.png": 3792,
	"./santam/topHeadBg.jpg": 9314,
	"./santam/topHeadLogo.png": 3524,
	"./santam/topHeadLogoLeft.png": 7621,
	"./santam/topHeadLogoRt.png": 1694,
	"./santam/topHeadLogoRt2.png": 3130,
	"./santam/topHeadLogoRtOLD.png": 4523,
	"./santam/topHeadLogoRtSantamClaims.jpg": 4369,
	"./santam/topHeadLogoRtSantamClaims.png": 204,
	"./santam/topRecognition.jpg": 8277,
	"./santam/topShoutOut.jpg": 6641,
	"./santam/topheadbg.png": 6089,
	"./santam/topheadbgSantamClaims.png": 9126,
	"./santam/voucherlogo.gif": 5051,
	"./santam/wait.gif": 5503,
	"./santam/wait300.gif": 4756,
	"./santamclientserviceaward.jpg": 1713,
	"./santamhumancapitalNorahSehunoe.jpg": 4808,
	"./santamsharedservices.jpg": 4327,
	"./spacer.gif": 9604,
	"./wait.gif": 5930,
	"./wait300.gif": 7752,
	"./whatsapp.svg": 3571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9300;